// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Nz72h{appearance:none;background:#fff;cursor:pointer;font-family:inherit;color:#1d1f3d;display:inline-flex;align-items:center;gap:8px;line-height:24px;border:2px solid #ebeaf2;border-radius:8px;padding:12px 16px;font-size:13px;font-weight:500;transition:border-color .15s ease}.Nz72h:hover:not(:disabled):not(.s4YxT){border-color:#b5b1d4}.Nz72h:disabled{cursor:not-allowed;opacity:.5}.Nz72h.s4YxT{border-color:#6c5ce7}.uLOiL{display:inline-flex;align-items:center}.T4HmD{outline:none;border-color:#6c5ce7}.T4HmD::placeholder{color:#9c9bb5}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chip": `Nz72h`,
	"selected": `s4YxT`,
	"label": `uLOiL`,
	"input": `T4HmD`
};
export default ___CSS_LOADER_EXPORT___;
